import type React from 'react';
import { useTranslation } from 'react-i18next';
import useChatMessageActions from '../../../../hooks/useChatMessageActions';
import type {
  ConversationMessageDataType,
  ConversationUserType,
} from '../../../../redux/ducks/ChatDucks.types';
import Button from '../../../button/Button';
import AppointmentSummaryBlock from './AppointmentSummaryBlock';
import MessageActionButtonsContainer from './MessageActionButtonsContainer';

export type AppointmentNewRequestMessageProps = {
  data: ConversationMessageDataType;
  user?: ConversationUserType;
  mine?: boolean;
  iamprovider: boolean;
  disabled: boolean;
};

const AppointmentNewRequestMessage: React.FC<
  AppointmentNewRequestMessageProps
> = ({ data, user, mine, iamprovider, disabled }) => {
  const { t } = useTranslation();
  const meta = data?.meta;
  const chatModifyModal = useChatMessageActions();

  if (!meta) {
    return null;
  }

  const onUserCancel = () => {
    console.log('User canceled new appointment', data);
    chatModifyModal.cancelNewAppointmentRequest();
  };

  const onUserConfirm = () => {
    console.log('User confirmed new appointment', data);
    chatModifyModal.confirmAppointment();
  };

  const onUserDeny = () => {
    console.log('User denied new appointment', data);
    chatModifyModal.denyAppointment();
  };

  const onProviderCancel = () => {
    console.log('Provider canceled new appointment', data);
    chatModifyModal.cancelNewAppointmentRequest();
  };

  const onProviderConfirm = () => {
    console.log('Provider confirmed new appointment', data);
    chatModifyModal.confirmAppointment();
  };

  const onProviderDeny = () => {
    console.log('Provider denied new appointment', data);
    chatModifyModal.denyAppointment();
  };

  return (
    <div className="flex min-w-full flex-col items-center justify-center">
      <div>
        <span className="mb-4 flex min-w-full flex-row items-center justify-center text-center text-base font-bold">
          {mine
            ? t('static.chat.message_header_appointment_new_mine', {
                name: `${user?.first_name} ${user?.last_name}`,
              })
            : t('static.chat.message_header_appointment_new_other', {
                name: `${user?.first_name} ${user?.last_name}`,
              })}
        </span>
        <AppointmentSummaryBlock data={data} />
      </div>
      {!disabled && (
        <MessageActionButtonsContainer data-test-id="new-request-message-btns">
          {!mine ? (
            <>
              <Button
                disabled={false}
                loading={false}
                label={t('static.chat.button_label_deny_appointment')}
                onClick={iamprovider ? onProviderDeny : onUserDeny}
                data-test-id={`chat-message-${data.id}-appointment-deny-action`}
                id={`chat-message-${data.id}-appointment-deny-action`}
                reject
              />
              <Button
                disabled={false}
                loading={false}
                label={t('static.chat.button_label_accept_appointment')}
                onClick={iamprovider ? onProviderConfirm : onUserConfirm}
                data-test-id={`chat-message-${data.id}-appointment-accept-action`}
                id={`chat-message-${data.id}-appointment-accept-action`}
                accept
              />
            </>
          ) : (
            <Button
              disabled={false}
              loading={false}
              label={t('static.chat.button_label_abort_appointment')}
              onClick={iamprovider ? onProviderCancel : onUserCancel}
              data-test-id={`chat-message-${data.id}-appointment-abort-action`}
              id={`chat-message-${data.id}-appointment-abort-action`}
              reject
            />
          )}
        </MessageActionButtonsContainer>
      )}
    </div>
  );
};

export default AppointmentNewRequestMessage;
